import React, { useState, useEffect } from 'react';
import isNil from 'utils/isNil';
import styled from 'styled-components';
import { STIcon } from 'components/Brand/Icons/STIcon';
import Cards from 'components/Cards/Cards';
import '../ImageCardCarouselSection.less';
import 'swiper/css/swiper.css';
import { Link } from 'gatsby';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { truncateText } from 'utils/text';

const ImageCardSliderToolbox = ({
  titleIcon,
  title,
  content,
  sectionsData,
  hubType,
  sectionsIcon,
  ...otherProps
}) => {
  const [moving, setMoving] = useState(false);
  const [isMobile, setMobile] = useState(false);
  const [isPad, setPad] = useState(false);
  const [isArrowShow, setIsArrowShow] = useState(false);
  const [isLeftArrowShow, setIsLeftArrowShow] = useState(false);
  const [isRightArrowShow, setIsRightArrowShow] = useState(true);
  let cardSlider = null;

  useEffect(() => {
    if (typeof window === 'object') {
      setMobile(window.innerWidth <= 576);
      setPad(window.innerWidth <= 768);
    }
  }, []);

  const contentTypeData = {
    ContentfulWebinar: {
      url: '/webinar/',
      category: 'Webinar',
      icon: sectionsIcon.webinar_logo,
    },
    ContentfulPodcast: {
      url: '',
      category: 'Podcast',
      icon: sectionsIcon.podcast_logo,
    },
    ContentfulBlog: {
      url: '/blog/',
      category: 'Article',
      icon: sectionsIcon.articles_logo,
    },
    ContentfulGatedContentPage: {
      url: '/guides/',
      category: 'Guide',
      icon: sectionsIcon.articles_logo,
    },
  };

  const params = {
    slidesPerView: 1,
    initialSlide: 0,
    grabCursor: true,
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 1,
      },
    },
    beforeChange: () => {
      setMoving(true);
    },
    afterChange: () => {
      setMoving(false);
    },
  };

  const sliderSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    arrows: false,
    autoplay: false,
    draggable: true,
    swipeToSlide: true,
    speed: 100,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
    beforeChange: (current, next) => {
      setMoving(true);

      setIsLeftArrowShow(next > 0);
      setIsRightArrowShow(next < sectionsData.length - (3 - (isPad ? 1 : 0)));
    },
    afterChange: () => {
      setMoving(false);
    },
  };

  const onArrowLeft = () => {
    cardSlider.slickPrev();
  };

  const onArrowRight = () => {
    cardSlider.slickNext();
  };

  return (
    <CardSliderSection
      className="clients-carousel"
      onMouseEnter={() => setIsArrowShow(true)}
      onMouseLeave={() => setIsArrowShow(false)}
    >
      <TopInfo>
        <Link id={title} className="slider-title" to={otherProps.viewAll}>
          {title}
        </Link>

        {!isNil(otherProps.viewAll) ? (
          <Link to={otherProps.viewAll} className="link-view-all">
            View All
          </Link>
        ) : (
          ''
        )}
      </TopInfo>

      <Slider
        className={`slider-wrapper${sectionsData.length < 3 ? ` left-align-slick` : ''}`}
        ref={slider => (cardSlider = slider)}
        {...sliderSettings}
      >
        {sectionsData.map((data, index) => {
          const src =
            data.featuredImage?.image?.fluid ||
            data.cardPhoto?.image?.fluid ||
            data.coverPhoto?.image?.fluid ||
            data.featuredImage?.fluid ||
            data.assetThumbnail?.fluid;
          const alt =
            data.featuredImage?.title ||
            data.assetThumbnail?.title ||
            data.featuredImage?.alt ||
            data.cardPhoto?.alt ||
            data.coverPhoto?.alt;

          return (
            <div className="slider-slide" key={index}>
              <a
                data-position="Body - Card CTA"
                className="card--link"
                {...(!moving && {
                  href:
                    hubType === 'coronavirus'
                      ? `${hubType}/${data.slug}`
                      : data?.tags?.includes('Covid19')
                      ? `coronavirus/${data.slug}`
                      : `${contentTypeData[data.__typename].url}${data?.seo?.pageUrl ||
                          data?.slug}`,
                })}
              >
                <Cards
                  type={'Image'}
                  bodyType={'simple'}
                  markIcon={contentTypeData[data.__typename].icon}
                  coverImage={
                    data.featuredImage || data.cardPhoto || data.coverPhoto || data.assetThumbnail
                  }
                  category={
                    data?.category?.split(',')?.join(' • ') ||
                    data?.taxonomy?.topics?.join(' • ') ||
                    contentTypeData[data.__typename].category
                  }
                  title={truncateText(
                    data?.title ||
                      data?.webinarTitle ||
                      data?.podcastTitle ||
                      data?.contentOfferTitle,
                    75
                  )}
                  description={``}
                />
              </a>
            </div>
          );
        })}
      </Slider>
      {!isMobile && (
        <div className="slider-arrow-container" style={{ opacity: isArrowShow ? '1' : '0' }}>
          {isLeftArrowShow && (
            <div className="slider-arrow--left-side">
              <div className="slider-arrow--left-arrow" onClick={onArrowLeft}>
                <STIcon type="icon-slider-arrow-left" />
              </div>
            </div>
          )}
          {isRightArrowShow && (
            <div className="slider-arrow--right-side">
              <div className="slider-arrow--right-arrow" onClick={onArrowRight}>
                <STIcon type="icon-slider-arrow-right" />
              </div>
            </div>
          )}
        </div>
      )}
    </CardSliderSection>
  );
};

export default ImageCardSliderToolbox;

const CardSliderSection = styled.div`
  position: relative;
  overflow: hidden;
  padding: 10px 0;

  .slider-title {
    font-family: 'Sofia Pro';
    font-weight: bold;
    font-size: 25px;
    line-height: 120%;
    letter-spacing: -0.01em;
    color: var(--white-color);

    img {
      margin-right: 13px;
    }

    &:hover {
      opacity: 0.7;
    }
  }
  .link-view-all {
    font-family: 'Sofia Pro';
    font-weight: 500;
    color: var(--white-color);
    line-height: 150%;
    font-size: 20px;
  }
  .left-align-slick > .slick-list > .slick-track {
    margin-left: 0px !important;
  }
  .slider-wrapper {
    max-width: 1258px;
    padding: 0 28px;
    margin: 0 auto 12px;

    .slider-slide {
      padding: 30px 20px;
    }

    .card--link {
      cursor: pointer;

      .ant-card {
        box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08) !important;
        justify-content: start;

        .ant-card-cover {
          background: transparent;
          justify-content: start;
          height: auto;
        }

        .ant-card-body {
          background: white;
          padding: 32px;

          .card-image-text {
            height: auto;
            padding-bottom: 0 !important;

            & > div {
              margin-bottom: 16px;
            }

            p {
              margin: 0;
            }
          }
        }
      }
    }

    .card--link.ads {
      width: 100%;
      height: 100%;
      display: block;
      box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08) !important;
      position: relative;
      top: 0;
      transition: all 0.3s;

      &:hover {
        top: -4px;
      }

      img {
        width: 100%;
        height: auto;
      }
    }

    .card-cover--image {
      min-height: 192px;
      max-height: 192px;
    }
  }

  .slick-list {
    overflow: visible;
  }

  .slick-prev:before,
  .slick-next:before {
    content: '' !important;
  }

  .slick-prev,
  .slick-next {
    display: flex !important;
    align-items: center;
    justify-content: center;
    border: none;
    width: 63px;
    height: 84px;
    background: var(--white-color);
    border-radius: 10px 0 0 10px;
    box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);

    &:hover {
      background: var(--white-color);
    }
  }

  .slick-prev {
    left: -80px;

    img {
      transform: rotate(180deg);
    }
  }

  .slick-next {
    right: -80px;
  }

  .slick-disabled {
    display: none !important;
  }

  .slick-track {
    display: flex;

    .slick-slide {
      height: auto;

      & > div {
        height: 100%;

        .slider-slide {
          height: 100%;
        }
      }
    }
  }

  .slider-arrow-container {
    width: 100%;
    height: calc(100% - 100px);
    position: absolute;
    top: 60px;
    pointer-events: none;
    transition: all 0.2s;

    .slider-arrow--left-side {
      width: 183px;
      height: 100%;
      position: absolute;
      top: 0;
      left: -107px;
      pointer-events: none;
      background: linear-gradient(270deg, rgba(34, 34, 34, 0.5) 47.25%, rgba(0, 0, 0, 0) 100%);
      transform: matrix(-1, 0, 0, 1, 0, 0);

      .slider-arrow--left-arrow {
        width: 63px;
        height: 84px;
        position: absolute;
        top: 50%;
        left: 13px;
        transform: translate(0, -50%);
        background: var(--white-color);
        border-radius: 5px 0 0 5px;
        box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
        }
      }
    }

    .slider-arrow--right-side {
      width: 183px;
      height: 100%;
      position: absolute;
      top: 0;
      right: -107px;
      pointer-events: none;
      background: linear-gradient(270deg, rgba(34, 34, 34, 0.5) 47.25%, rgba(0, 0, 0, 0) 100%);
      transform: matrix(1, 0, 0, -1, 0, 0);

      .slider-arrow--right-arrow {
        width: 63px;
        height: 84px;
        position: absolute;
        top: 50%;
        left: 13px;
        transform: translate(0, -50%);
        background: var(--white-color);
        border-radius: 5px 0 0 5px;
        box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          margin-left: 10px;
        }
      }
    }
  }

  @media (max-width: 1414px) {
    .slick-next {
      width: 50px;
      height: 50px;
      right: -25px;
      border-width: 1px;

      img {
        transform: scale(0.6);
      }
    }

    .slick-prev {
      width: 50px;
      height: 50px;
      left: -25px;
      border-width: 1px;

      img {
        transform: rotate(180deg) scale(0.6);
      }
    }
  }

  @media (max-width: 1283px) {
    margin-bottom: 20px;

    .slider-wrapper {
      margin: 0 20px 0px;
    }

    .slider-arrow-container {
      height: calc(100% - 89px);

      .slider-arrow--left-side {
        left: -137px;

        .slider-arrow--left-arrow {
          width: 53px;
          height: 70px;
          left: -7px;

          svg {
            width: 16px;
          }
        }
      }

      .slider-arrow--right-side {
        right: -137px;

        .slider-arrow--right-arrow {
          width: 53px;
          height: 70px;
          left: -7px;

          svg {
            width: 16px;
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .slider-wrapper {
      .slider-slide {
        padding: 30px 10px;
      }
    }

    .slider-wrapper {
      margin: 0 30px 0px;
    }
  }

  @media (max-width: 576px) {
    .slider-wrapper {
      margin-left: -10px;
      margin-right: 0;
      padding: 0 0 0 20px;

      .card-cover--image {
        min-height: 171px !important;
        max-height: 200px;
      }

      .card-image-text {
        height: 200px;
      }
    }
    .link-view-all {
      display: none !important;
    }
    .slick-arrow {
      display: none !important;
    }
  }
`;

const TopInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 1219px;
  padding: 0 28px;
  margin: 0 auto;

  @media (max-width: 1283px) {
    padding: 0 23px;
    margin: 0 45px;
  }

  @media (max-width: 991px) {
    margin: 0 45px;
  }

  @media (max-width: 576px) {
    margin: 0;
    padding: 0 20px;
  }
`;
